export const getMultibyteLen = str => {
  let result = 0
  for (let i = 0; i < str.length; i++) {
    let chr = str.charCodeAt(i)
    if (
      (chr >= 0x00 && chr < 0x81) ||
      chr === 0xf8f0 ||
      (chr >= 0xff61 && chr < 0xffa0) ||
      (chr >= 0xf8f1 && chr < 0xf8f4)
    ) {
      result += 1
    } else {
      result += 2
    }
  }
  return result
}

export default {
  computed: {
    rules () {
      return {
        required: value => {
          return value === 0 || !!value || this.$t('_rules.required')
        },
        integer: value => {
          const pattern = /^-?[0-9]*$/
          return pattern.test(value) || this.$t('_rules.integer')
        },
        positive: value => {
          const pattern = /^[0-9.]*$/
          return pattern.test(value) || this.$t('_rules.positive')
        },
        no_zero: value => {
          const pattern = /^-?[0]*$/
          return !pattern.test(value) || this.$t('_rules.no_zero')
        },
        decimal: value => {
          const pattern = /^-?\d*(\.\d{1,})?$/
          return pattern.test(value) || this.$t('_rules.decimal')
        },
        date: value => {
          if (!value) {
            return true
          }
          return (
            this.$moment(value, 'YYYY-MM-DD', true).isValid() ||
            this.$t('_rules.date_format')
          )
        },
        percentage: value => {
          return value >= 0 && value <= 100
            ? true
            : this.$t('_rules.between', { min: 0, max: 100 })
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (Array.isArray(value)) {
            const invalid = value.filter(v => {
              return !pattern.test(v)
            })
            return invalid.length === 0 || this.$t('_rules.email')
          }
          return pattern.test(value) || this.$t('_rules.email')
        },
        max: (value, max) => {
          return value <= max ? true : this.$t('_rules.max', { max: max })
        },
        min: (value, min) => {
          return value >= min ? true : this.$t('_rules.min', { min: min })
        },
        max_not_equal: (value, max) => {
          return value < max
            ? true
            : this.$t('_rules.max_not_equal', { max: max })
        },
        min_not_equal: (value, min) => {
          return value > min
            ? true
            : this.$t('_rules.min_not_equal', { min: min })
        },
        between: (value, min, max) => {
          return value >= min && value <= max
            ? true
            : this.$t('_rules.between', { min: min, max: max })
        },
        formula: value => {
          if (value === null) {
            return true
          }
          const pattern = /^-?[0-9+\-*/^%().]*$/
          return pattern.test(value) || this.$t('_rules.formula')
        },
        max_length: (value, length, multibyte = false) => {
          if (!value) {
            return false
          }
          const l = multibyte ? getMultibyteLen(value) : value.length
          return l <= length
            ? true
            : this.$t('_rules.max_length', { length: length })
        }
      }
    }
  },
  methods: {
    hasRuleError () {
      return this._hasRuleError(this.$refs)
    },
    _hasRuleError (refs) {
      const errors = Object.keys(refs).map(key => {
        const ref = refs[key]
        if (ref === undefined) {
          return false
        }
        if (Array.isArray(ref)) {
          return this._hasRuleError(ref)
        }
        if (ref && typeof ref.validate === 'function') {
          ref.validate(true)
          return ref.hasError
        } else if (ref && ref.$refs) {
          return this._hasRuleError(ref.$refs)
        }
        return false
      })
      return errors.some(e => e)
    },
    resetRuleError () {
      this._resetRuleError(this.$refs)
    },
    _resetRuleError (refs) {
      Object.keys(refs).forEach(key => {
        const ref = refs[key]
        if (Array.isArray(ref)) {
          this._resetRuleError(ref)
        } else {
          if (ref && typeof ref.reset === 'function') {
            ref.reset()
          } else if (ref && ref.$refs) {
            this._resetRuleError(ref.$refs)
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/rules.js